import { Box, Flex } from '@chakra-ui/react';
import Image from 'next/image';

export type TeamMemberProps = {
  image: string;
  name: string;
  role: string;
};

const TeamMember = ({ image, name, role }: TeamMemberProps) => (
  <Flex textAlign="center" align="center" justify="center" direction="column">
    <Box>
      <Image
        className="team-member-image"
        width={283}
        height={283}
        src={image}
        alt={name}
      />
    </Box>
    <Box fontWeight="bold" mt={6} fontSize="xl" as="span">
      {name}
    </Box>
    <Box fontWeight="semibold" mt={3} fontSize="lg" as="span" color="brand.500">
      {role}
    </Box>
  </Flex>
);

export default TeamMember;
